import { Helmet } from "react-helmet";
import { Box, Typography } from "@mui/material";

const birdPhotos = [
	require("../Images/Baby_Bird_Photos/baby_ducks.jpeg"),
	require("../Images/Baby_Bird_Photos/chickens.jpeg"),
	require("../Images/Baby_Bird_Photos/gb.JPG"),
];

export default function EggsInverGroveHeights() {
	return (
		<Box p={2}>
			{/* ================= SEO META ================= */}
			<Helmet>
				<title>
					Fresh Chicken & Duck Eggs in Inver Grove Heights, MN | Local Farm Eggs
				</title>
				<meta
					name="description"
					content="Looking for fresh chicken and duck eggs in Inver Grove Heights, Minnesota? Visit our local farm stand for ethically raised, high-quality eggs just minutes from the Twin Cities."
				/>
				<meta
					name="keywords"
					content="eggs Inver Grove Heights MN, fresh eggs near me, duck eggs Minnesota, farm fresh eggs Twin Cities, local eggs Inver Grove Heights"
				/>
			</Helmet>

			{/* ================= PAGE CONTENT ================= */}
			<article className="seo-blog eggs-page">
				<header>
					<h1>Fresh Chicken & Duck Eggs in Inver Grove Heights, Minnesota</h1>
					<p>
						<em>
							Ethically raised, farm-fresh eggs just minutes from the Twin
							Cities
						</em>
					</p>
					<Box
						display="flex"
						flexDirection={{ xs: "column", sm: "row" }}
						justifyContent="center"
						alignItems="center"
						gap={2}
						mt={2}
						mb={2}
					>
						<Box>
							<img
								src={birdPhotos[0]}
								alt="Baby ducks at Gosell Gardens"
								style={{
									width: "100%",
									maxWidth: 320,
									borderRadius: 12,
									objectFit: "cover",
									boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
								}}
						loading="lazy"
							/>
							<Typography variant="caption" display="block" textAlign="center">
								Our adorable baby ducks enjoying a sunny day
							</Typography>
						</Box>
						<Box>
							<img
								src={birdPhotos[1]}
								alt="Chickens at Gosell Gardens"
								style={{
									width: "100%",
									maxWidth: 320,
									borderRadius: 12,
									objectFit: "cover",
									boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
								}}
						loading="lazy"
							/>
							<Typography variant="caption" display="block" textAlign="center">
								Our happy chickens scratching around at Gosell Gardens
							</Typography>
						</Box>
					</Box>
				</header>

				<section>
					<p>
						If you’re searching for{" "}
						<strong>fresh eggs in Inver Grove Heights, MN</strong>, you’ve come
						to the right place. Our small local farm offers high-quality{" "}
						<strong>chicken eggs and duck eggs</strong> raised with care,
						transparency, and a strong focus on animal welfare.
					</p>
					<p>
						Located conveniently near the Twin Cities, our self-serve farm stand
						makes it easy to enjoy truly farm-fresh eggs without the grocery
						store experience.
					</p>
				</section>

				<section>
					<h2>About Our Farm &amp; How We Raise Our Birds</h2>
					<p>
						Our farm is home to approximately{" "}
						<strong>100 chickens and 20 ducks</strong>, all raised ethically in
						a clean, well-maintained coop environment. We believe that great
						eggs start with well-cared-for animals.
					</p>
					<p>
						That’s why we feed our birds some of the{" "}
						<strong>
							highest-quality feed available, produced by Purina and Mazuri
						</strong>
						. The result is eggs with excellent flavor, strong shells, and rich
						yolks - a noticeable difference from store-bought eggs.
					</p>
				</section>

				<section>
					<h2>Our Eggs: Sizes, Colors &amp; Pricing</h2>

					<h3>🥚 Chicken Eggs</h3>
					<ul>
						<li>Natural shell colors including brown and light green hues</li>
						<li>Collected fresh and rotated frequently</li>
						<li>
							<strong>$5 per dozen</strong>
						</li>
					</ul>

					<h3>🦆 Duck Eggs</h3>
					<ul>
						<li>Noticeably larger than chicken eggs</li>
						<li>Richer flavor and creamier texture</li>
						<li>Excellent for baking and cooking</li>
						<li>
							<strong>$4 per half dozen or $8 per dozen</strong>
						</li>
					</ul>
				</section>

				<section>
					<h2>Why Choose Duck Eggs?</h2>
					<p>
						Duck eggs are a favorite among bakers and home cooks. Their richer
						yolks and higher fat content make them especially popular for
						baking.
					</p>
					<p>
						Around the holidays, duck eggs are our go-to choice for{" "}
						<strong>chocolate chip cookies and oatmeal raisin cookies</strong>.
						They produce a soft, flavorful texture that’s hard to beat.
					</p>
					<p>
						We’ve even had cookies made with our duck eggs mysteriously
						disappear before they could be shared with neighbors.
					</p>
					<Box
						display="flex"
						flexDirection={{ xs: "column", sm: "row" }}
						justifyContent="center"
						alignItems="center"
						gap={2}
						mt={2}
						mb={2}
					>
						<Box>
							<img
								src={birdPhotos[2]}
								alt="Gosell Gardens birds"
								style={{
									width: "100%",
									maxWidth: 400,
									borderRadius: 12,
									objectFit: "cover",
									boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
								}}
						loading="lazy"
							/>
							<Typography variant="caption" display="block" textAlign="center">
								This is GB one of our friendliest chickens!
							</Typography>
						</Box>
					</Box>
				</section>

				<section>
					<h2>Farm Stand Pickup in Inver Grove Heights</h2>
					<p>
						We operate a convenient{" "}
						<strong>farm stand located at the end of our driveway</strong> here
						in <strong>Inver Grove Heights, Minnesota</strong>.
					</p>
					<p>
						Directions, hours, and pickup details are available directly on our{" "}
						<a href="/" style={{ color: "#1976d2" }}>
							homepage
						</a>{" "}
						and
						<a href="/farmstand" style={{ color: "#1976d2", marginLeft: 4 }}>
							farm stand info
						</a>{" "}
						pages.
					</p>
				</section>

				<section>
					<h2>Online Egg Requests &amp; Easy Pickup</h2>
					<p>
						To make things even easier, we offer an{" "}
						<strong>online egg request system</strong>. Customers can request
						eggs through our{" "}
						<a href="/egg-list" style={{ color: "#1976d2" }}>
							egg request page
						</a>{" "}
						at their convenience.
					</p>
					<p>
						Once the eggs are ready, you’ll receive an email notification
						letting you know they’re available for pickup. Some customers place
						larger orders - including <strong>25 eggs or more</strong> - and
						appreciate the flexibility of managing everything through their
						customer portal.
					</p>
				</section>

				<section>
					<h2>Serving Inver Grove Heights &amp; the Twin Cities</h2>
					<p>
						Our farm is proudly located in{" "}
						<strong>Inver Grove Heights, MN</strong>, just a short drive from
						Saint Paul, Minneapolis, and the surrounding Twin Cities metro area.
					</p>
					<p>
						If you’re looking for <strong>local eggs near you</strong>, our farm
						offers a simple, trustworthy option that supports small-scale
						agriculture.
					</p>
				</section>

				<section>
					<h2>Visit Us for Farm-Fresh Eggs</h2>
					<p>
						Whether you’re a home cook, a baker, or someone who values knowing
						where their food comes from, we’d love to have you stop by.
					</p>
					<p>
						Fresh chicken eggs, rich duck eggs, and a welcoming local farm
						experience - all right here in Inver Grove Heights.
					</p>
					<p>
						<strong>
							Check out our
							<a href="/farmstand" style={{ color: "#1976d2", marginLeft: 4 }}>
								farm stand hours
							</a>
							, and
							<a href="/egg-list" style={{ color: "#1976d2", marginLeft: 4 }}>
								request eggs online
							</a>
							.
						</strong>
					</p>
				</section>
			</article>
		</Box>
	);
}
